package kz.dentalcrm.app.data.network.response_model

import kotlinx.serialization.Serializable
import kz.dentalcrm.app.core.utils.FlexibleBooleanSerializer
import kz.dentalcrm.app.data.network.response_model.employees.Employee

@Serializable
data class AppointmentDataResponse(
    val `data`: AppointmentResponse
)

@Serializable
data class AppointmentResponse(
    val color: String? = null,
    val created_at: String? = null,
    val deleted_at: String? = null,
    val employee: Employee? = null,
    val employee_id: Int? = null,
    val ends_at: String? = null,
    val id: Int,
    @Serializable(with = FlexibleBooleanSerializer::class)
    val is_first_visit: Boolean? = null,
    val patient: PatientData? = null,
    val patient_id: Int? = null,
    val price: Int? = null,
    val services: List<Service>? = null,
    val starts_at: String? = null,
    val status: String? = null,
    val comment: String? = null,
    val title: String? = null,
    val treatment_course: TreatmentCourse? = null,
    val treatment_course_id: Int? = null,
    val updated_at: String? = null,
    val initial_inspection: InitialInspection? = null,
    val cash_box_id: Int? = null
)